import { render, staticRenderFns } from "./upload_producer_documents_modal.vue?vue&type=template&id=36362284&scoped=true"
import script from "./upload_producer_documents_modal.vue?vue&type=script&lang=js"
export * from "./upload_producer_documents_modal.vue?vue&type=script&lang=js"
import style0 from "./upload_producer_documents_modal.vue?vue&type=style&index=0&id=36362284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36362284",
  null
  
)

export default component.exports